import * as React from 'react'

import TextField, { TextFieldProps } from '@material-ui/core/TextField'
import { InjectedFormikProps }       from 'formik'
import { FormattedMessage }          from 'react-intl'

import { pick } from '../../utils'

interface AbstractedTextFieldProps extends TextFieldProps,
  InjectedFormikProps<any, any> {
  identifier: string
}

class AbstractedFormikTextField extends React.Component<any> {
  public render () {
    const {
      values,
      touched,
      errors,
      handleChange,
      handleBlur,
      identifier,
      label,
      ...rest
    } = this.props

    const TextFieldPropsRest: TextFieldProps = pick(
      rest,
      [
        'autoComplete',
        'autoFocus',
        'children',
        'defaultValue',
        'disabled',
        'error',
        'FormHelperTextProps',
        'fullWidth',
        'helperText',
        'id',
        'InputLabelProps',
        'InputProps',
        'inputProps',
        'inputRef',
        'label',
        'margin',
        'multiline',
        'name',
        'onChange',
        'placeholder',
        'required',
        'rows',
        'rowsMax',
        'select',
        'SelectProps',
        'type',
        'value',
      ],
    )

    const i18nLabelId = label || identifier

    const phrasing = ({
      label: <FormattedMessage id={'labels.' + i18nLabelId} />,
      error: errors[ identifier ]
               ? <FormattedMessage id={'validation.' + errors[ identifier ]} />
               : '',
    })

    const errorText =
      touched[ identifier ]
      && phrasing.error
      || ''

    return (
      <TextField
        label={phrasing.label}
        name={identifier}
        value={values[ identifier ]}
        error={!!errorText}
        helperText={errorText}
        onChange={handleChange}
        onBlur={handleBlur}
        {...TextFieldPropsRest}
      />
    )
  }

  public shouldComponentUpdate (nextProps: AbstractedTextFieldProps) {
    return this.props !== nextProps
  }
}

export default AbstractedFormikTextField



// WEBPACK FOOTER //
// ./src/components/atoms/AbstractedFormikTextField.tsx